import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import ServiceDetail from "@/pages/ServiceDetail";
import Privatkunden from "@/pages/Privatkunden";
import Geschaeftskunden from "@/pages/Geschaeftskunden";
import Referenzen from "@/pages/Referenzen";
import ProjectDetail from "@/pages/ProjectDetail";
import UeberUns from "@/pages/UeberUns";
import Einsatzgebiete from "@/pages/Einsatzgebiete";
import RegionDetail from "@/pages/RegionDetail";
import CityDetail from "@/pages/CityDetail";
import LocalPage from "@/pages/LocalPage";
import { localPages } from "@/data/localPages";
import Ratgeber from "@/pages/Ratgeber";
import ArticleDetail from "@/pages/ArticleDetail";
import Kontakt from "@/pages/Kontakt";
import AnfrageErfolgreich from "@/pages/AnfrageErfolgreich";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import CookieEinstellungen from "@/pages/CookieEinstellungen";
import NotFound from "@/pages/NotFound";

import { AuthProvider } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Inquiries from "@/pages/admin/Inquiries";
import InquiryDetail from "@/pages/admin/InquiryDetail";
import Projects from "@/pages/admin/Projects";
import Cities from "@/pages/admin/Cities";
import Performance from "@/pages/admin/Performance";
import Employees from "@/pages/admin/Employees";
import Reviews from "@/pages/admin/Reviews";
import EmployeeLayout from "@/components/employee/EmployeeLayout";
import Timesheet from "@/pages/employee/Timesheet";

function AuthArea() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          {/* Public site */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/leistungen/:slug" element={<ServiceDetail />} />
            <Route path="/privatkunden" element={<Privatkunden />} />
            <Route path="/geschaeftskunden" element={<Geschaeftskunden />} />
            <Route path="/referenzen" element={<Referenzen />} />
            <Route path="/referenzen/:slug" element={<ProjectDetail />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/einsatzgebiete" element={<Einsatzgebiete />} />
            <Route path="/einsatzgebiete/:slug" element={<RegionDetail />} />
            <Route path="/entruempelung/:slug" element={<CityDetail />} />
            {localPages.map((p) => (
              <Route key={p.slug} path={`/${p.slug}`} element={<LocalPage slug={p.slug} />} />
            ))}
            <Route path="/ratgeber" element={<Ratgeber />} />
            <Route path="/ratgeber/:slug" element={<ArticleDetail />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/anfrage-erfolgreich" element={<AnfrageErfolgreich />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/cookie-einstellungen" element={<CookieEinstellungen />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Auth area: shared login + admin + employee (own auth context, noindex) */}
          <Route element={<AuthArea />}>
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="anfragen" element={<Inquiries />} />
              <Route path="anfragen/:id" element={<InquiryDetail />} />
              <Route path="projekte" element={<Projects />} />
              <Route path="bewertungen" element={<Reviews />} />
              <Route path="orte" element={<Cities />} />
              <Route path="performance" element={<Performance />} />
              <Route path="mitarbeiter" element={<Employees />} />
            </Route>
            <Route path="/mitarbeiter" element={<EmployeeLayout />}>
              <Route index element={<Timesheet />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </HelmetProvider>
  );
}

export default App;
